import { Button, ButtonGroup, DataTable, Text } from '@shopify/polaris';
import { EditIcon, ViewIcon } from '@shopify/polaris-icons';
import CustomBadge from '#client/components/common/CustomBadge/CustomBadge';
import PURCHASE_ORDER_STRINGS from '#client/pages/PurchaseOrders/constants/purchaseOrders.en.json';
import '#client/pages/PurchaseOrders/PurchaseOrderReceivingDocument/styles/PurchaseOrderReceivingDocument.css';
import { formatDateToUTC } from '#client/utils/helpers';

/**
 *
 * @param {Array} param.receivingDocumentRows - Array of receiving document rows to be displayed in the table
 * @param {Function} param.navigate - Function to navigate to a different route
 * @param {string} param.receivingDocumentSortDirection - Current sort direction for the receiving documents
 * @param {number} param.receivingDocumentSortColumnIndex - Current sorted column index for the receiving documents
 * @param {Function} param.handleSort - Function to handle sorting of the table
 * @description ReceivingDocumentsTable component displays a table of receiving documents with their details and actions.
 * @returns
 */
const ReceivingDocumentsTable = ({ cartonRows, handleSort, navigate, receivingDocumentRows, receivingDocumentSortDirection, receivingDocumentSortColumnIndex, isAuditRequired, parentData }) => {
    return (
        <>
            <Text variant="headingLg">{PURCHASE_ORDER_STRINGS.PURCHASE_ORDER_ASN.RECEIVING_DOCUMENTS_TABLE.RECEIVING_DOCUMENTS}</Text>
            <DataTable
                columnContentTypes={['text', 'text', 'text', 'text']}
                defaultSortDirection="ascending"
                headings={[`${PURCHASE_ORDER_STRINGS.DOCUMENT_ID}`, `${PURCHASE_ORDER_STRINGS.STATUS}`, `${PURCHASE_ORDER_STRINGS.DATE_CREATED}`, `${PURCHASE_ORDER_STRINGS.ACTIONS}`]}
                initialSortColumnIndex={0}
                onSort={(columnIndex, direction) => {
                    handleSort(columnIndex, direction);
                }}
                rows={receivingDocumentRows.map((row) => [
                    <Text key={`rd-${row.id}`}>{row.name}</Text>,
                    <CustomBadge key={`badge-${row.id}`} status={row.status} />,
                    formatDateToUTC(row.createdAt),
                    <ButtonGroup align="end" gap="0" key={`actions-${row.id}`}>
                        <Button
                            icon={ViewIcon}
                            key={`view-${row.id}`}
                            variant="plain"
                            onClick={() =>
                                navigate(`receiving-document/${row.id}`, {
                                    state: {
                                        status: row.status,
                                        cartonRows,
                                        netsuiteId: parentData?.netsuiteId,
                                        asnNetsuiteId: parentData?.asnNetsuiteId,
                                        isAuditRequired,
                                        parentData: parentData,
                                        navigateFromASN: true,
                                    },
                                })
                            }
                        />
                        {row.status === 'pending' && (
                            <Button
                                icon={EditIcon}
                                key={`edit-${row.id}`}
                                variant="plain"
                                onClick={() =>
                                    navigate(`receiving-document/${row.id}`, {
                                        state: {
                                            status: row.status,
                                            cartonRows,
                                            netsuiteId: parentData?.netsuiteId,
                                            asnNetsuiteId: parentData?.asnNetsuiteId,
                                            isAuditRequired,
                                            parentData: parentData,
                                        },
                                    })
                                }
                            />
                        )}
                    </ButtonGroup>,
                ])}
                sortable={[true, true, true, false]}
                sortedColumnIndex={receivingDocumentSortColumnIndex}
                sortDirection={receivingDocumentSortDirection}
            />
        </>
    );
};

export default ReceivingDocumentsTable;
